import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useProfileQuery } from "@/hooks/profile/useProfileQuery";

export const useReservationCategories = (gymId?: string) => {
  const { data: profile } = useProfileQuery();
  
  // ALWAYS prioritize the provided gymId. Only use profile.gym_id if no gymId is provided
  // This prevents inconsistency when user manages gym via gym_managers vs profile.gym_id
  const targetGymId = gymId || profile?.gym_id;
  
  // Debug logging (temporary)
  console.log('[useReservationCategories] Debug info:', {
    providedGymId: gymId,
    profileGymId: profile?.gym_id,
    targetGymId,
    profileRole: profile?.role
  });

  return useQuery({
    queryKey: ['reservation-categories', targetGymId],
    queryFn: async () => {
      if (!targetGymId) {
        console.log('[useReservationCategories] No targetGymId available, returning empty array');
        return [];
      }

      console.log('[useReservationCategories] Fetching categories for gym:', targetGymId);

      const { data, error } = await supabase
        .from('reservation_categories')
        .select('*')
        .eq('gym_id', targetGymId)
        .eq('is_active', true)
        .order('name');

      if (error) {
        console.error('[useReservationCategories] Error fetching categories:', error);
        throw error;
      }
      
      console.log('[useReservationCategories] Categories found:', data?.length || 0);
      return data || [];
    },
    enabled: !!targetGymId,
    // Add staleTime to prevent unnecessary refetches
    staleTime: 30000, // 30 seconds
  });
};